import type { PlatformBridge } from './PlatformBridge';

export const webBridge: PlatformBridge = {
  platform: 'web',
};
